import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { hideModal } from '../../../redux/actions'
import { useDebounce } from '../../../hooks/UseDebounce'
import { Box, Button, Grid } from '@mui/material'
import { ModalContainer } from '../../Modals/ModalContainer'
import { FormAutoCompleteInput } from '../../@Common/Form/AutoComplete/FormAutoComplete'
import { useForm } from 'react-hook-form'



function MigrateListingToPartnerModal({
    listing,
    getPartners,
    saveMigrateListingToPartner,
    refreshPartnerData,
    hasCodePoolOffers
}) {
    const dispatch = useDispatch()
    const { 
        control,
        watch,
     } = useForm({
        defaultValues: {
            partner: null,
        },
    })
    const [processing, setProcessing] = useState(false)
    const [showError, setShowError] = useState({isError: false, Error: ""})
    const [searchTerm, setSearchTerm] = useState('')
    const debouncedSearchTerm = useDebounce(searchTerm, 200)
    const selectedPartner = watch('partner')
    const codePoolError = 'Unable to move listing with code pool offers. The offers must be deleted prior to moving this listing.'

    const { partners, isPartnerFetchLoading } = getPartners(debouncedSearchTerm, true)
    const noOptionsText = () => {
        if (debouncedSearchTerm === '')
        return 'Search for a partner'
        else if (isPartnerFetchLoading)
        return 'Loading...'
        else
        return 'No partner found'
    }

    const saveMigration = () => {
        setProcessing(true)
        saveMigrateListingToPartner({listingId: listing.id, partnerId: selectedPartner.id}).then((response) => {
            if (response.data?.error == 'CodePools Linked') {
                setShowError({isError: true, Error: codePoolError})
            } else {
                refreshPartnerData?.()
                setProcessing(false)
                dispatch(hideModal())
            }
        }).catch((error) => {
            console.error('Migration failed:', error)
        })
        .finally(() => {
            setProcessing(false)
        })
    }

    useEffect(() => {
        hasCodePoolOffers?.(listing.id).then((response) => {
            if(response.data) {
                setShowError({
                    isError: true,
                    Error: codePoolError,
                })
            }
        })
    }, [])

    return (
        <ModalContainer
            title={"Move Partners"}
            maxWidth="sm"
            fullWidth="true"
            hideModal={() => { }}
            processing={processing}
        >
            {showError.isError ? 
                <Box sx={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem'}}>
                    {showError.Error}
                </Box>
            :
                <Box sx={{ mb: '30px' }}>
                    <FormAutoCompleteInput
                        name="partner"
                        label="Partner"
                        noOptionsText={noOptionsText()}
                        options={partners}
                        control={control}
                        onInputChange={(event, newInputValue) => setSearchTerm(newInputValue)}
                        itemLabelKey='name'
                        rules={{
                        required: {
                            value: true,
                            message: 'Partner name is required',
                        },
                        }}
                        gxid="createCodePoolPartner"
                    />
                </Box>
            }
            <Grid container sx={{ marginTop: '10px' }} justifyContent="flex-end" spacing={2}>
                <Grid item xs={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => saveMigration()}
                        label={'Search'}
                        disabled={showError.isError}
                        style={{
                            minHeight: '36px',
                        }}
                    >
                        Save
                    </Button>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        variant="text"
                        onClick={() => dispatch(hideModal())}
                        label={'Cancel'}
                        style={{
                            minHeight: '36px',
                            minWidth: '64px',
                        }}
                    >
                        Cancel
                    </Button>
                </Grid>
            </Grid>
        </ModalContainer>
    )
}

export default MigrateListingToPartnerModal    